import React from 'react';
import classnames from 'classnames';
import { DH } from '../../../utils/dataHooks';
import { Locale } from '../../../types/Locale';
import { Shape } from '../../../types/Styles';
import s from './styles.scss';

interface ApplePayProps {
  height: number;
  locale: Locale;
  color: string;
  shape: Shape;
  onClick(): void;
}

export class ApplePayView extends React.Component<ApplePayProps> {
  style() {
    return {
      height: `${this.props.height}px`,
    };
  }

  render() {
    const { onClick, locale, color, shape } = this.props;
    return (
      <section data-hook={'apple-pay-view'}>
        <button
          lang={locale}
          data-hook={DH.ApplePay.Button}
          style={this.style()}
          className={classnames(s.applePayButton, s[color], s[shape])}
          onClick={onClick}
        ></button>
      </section>
    );
  }
}
